import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, GuardResult, MaybeAsync, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { OAuthService } from 'angular-oauth2-oidc';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {

  constructor(private oidcSecurityService: OidcSecurityService, private router: Router) {}

  

  canActivate(): Observable<boolean | UrlTree> {

    // Check if the user is authenticated
    return this.oidcSecurityService.checkAuth().pipe(
      map((isAuthenticated) => {
        // console.log('******', isAuthenticated);
        if (isAuthenticated.isAuthenticated) {
          return true; // Allow access
        } else {
          // Redirect to the login page if not authenticated
          // this.oidcSecurityService.authorize();
          return this.router.createUrlTree(['/']);
          // return false;
        }
      })
    );

    // canActivate(): Observable<boolean | UrlTree> {
    // Check if the user is authenticated

    // return true;
    // return this.OidcSecurityService.isAuthenticated$.pipe(
    //   map((isAuthenticated) => {
    //     if (isAuthenticated.isAuthenticated) {
    //       this.router.createUrlTree(['/user/account']);         
    //       return true; // Allow access
    //     } else {
    //       // Redirect to the login page if not authenticated
    //       // this.router.createUrlTree(['/']);
    //       this.OidcSecurityService.authorize();
    //       return false
    //     }
    //   })
    // );

    // return this.OidcSecurityService.isAuthenticated$.pipe(
    //   map((isAuthenticated) => {
    //     if (isAuthenticated.isAuthenticated) {
    //       this.router.createUrlTree(['/user/account']);         
    //       return true; // Allow access
    //     } else {
    //       // Redirect to the login page if not authenticated
    //       this.router.createUrlTree(['/']);
    //       return false
    //     }
    //   })
    // );
  }
}
